<script lang="ts">
	import Carousel from "@components/common/Carousel.svelte";
	import autoScroll from "embla-carousel-auto-scroll";
	import InfoBannerLanguageSwitcher from "./InfoBannerLanguageSwitcher.svelte";

	const { messages }: { messages: string[] } = $props();
</script>

<div
	class="bg-fcrbrown h-[var(--info-banner-height)] sm:pl-2 lg:pl-4 relative text-sm/[var(--info-banner-height)] text-white"
>
	<InfoBannerLanguageSwitcher />
	<div
		class="absolute inset-0 pointer-events-none select-none overflow-hidden max-w-[105rem] mx-auto justify-between contents sm:grid grid-cols-[1fr_auto_1fr]"
	>
		<div class="relative sm:w-screen sm:max-w-[calc(var(--container-width)-10rem)] md:max-lg:max-w-[80vw] col-start-2">
			<Carousel items={messages} options={{ loop: true, align: "start" }} plugins={[autoScroll({ speed: 0.75 })]}>
				{#snippet item(message)}
					<div class="!max-w-[unset] text-nowrap shrink-0 px-40">
						{message}
					</div>
				{/snippet}
			</Carousel>
			<div
				class="absolute left-0 top-0 text-fcrbrown sm:bg-[linear-gradient(to_right,currentColor,transparent)] h-full w-12"
			></div>
			<div
				class="absolute right-0 top-0 text-fcrbrown sm:bg-[linear-gradient(to_left,currentColor,transparent)] h-full w-12"
			></div>
		</div>
	</div>
</div>
